import type { ConversationThreadResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface InstagramThreadViewProps {
  thread: ConversationThreadResponse;
}

export const InstagramThreadView = memo(function InstagramThreadView({
  thread,
}: InstagramThreadViewProps) {
  return <ChatThreadView channel="instagram" thread={thread} />;
});
